var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pl-0 text-center col-lg-12"},[_c('h3',[_vm._v("Masterlist Section")])]),_c('div',{staticClass:"pl-0 col-lg-3"})])])
}]

export { render, staticRenderFns }